<!-- Toggle Button -->
<button class="side-panel__toggle" (click)="toggle()" type="button" aria-label="Toggle navigation menu">
  <rms-hover-icon
    *ngIf="!isOpen"
    [staticIconSVG]="'assets/icons/header/hamburger-icon.svg'"
    [hoverIconSVG]="'assets/icons/header/hamburger-icon-bold.svg'"
    [iconHeight]="'19'">
  </rms-hover-icon>
  <rms-hover-icon
    *ngIf="isOpen"
    [staticIconSVG]="'assets/icons/header/close-icon.svg'"
    [hoverIconSVG]="'assets/icons/header/close-icon-bold.svg'"
    [iconHeight]="'19'">
  </rms-hover-icon>
</button>

<!-- Overlay -->
<div
  class="side-panel__overlay"
  [class.side-panel__overlay--visible]="isOpen"
  tabindex="0"
  (click)="close()"
  (keydown.enter)="close()">
</div>

<!-- Panel -->
<aside class="side-panel__panel" [class.side-panel__panel--open]="isOpen">
  <!-- Navigation (only shown when header nav is collapsed) -->
  <nav *ngIf="showNavItems" class="side-panel__nav">
    <ul class="side-panel__nav-list">
      <ng-container *ngFor="let item of menu">
        <li
          *ngIf="item.subMenu === null || item.subMenu?.length > 0"
          class="side-panel__nav-item"
          [class.side-panel__nav-item--has-children]="item.subMenu"
          [class.side-panel__nav-item--open]="item.open"
          [routerLinkActive]="['side-panel__nav-item--active']">

          <!-- Item without submenu -->
          <a
            *ngIf="!item.subMenu"
            class="side-panel__nav-link"
            [routerLink]="item.link"
            (click)="onMenuItemClick(item)">
            {{ item.textKey | translate }}
            <i *ngIf="item.icon" class="fa fa-{{ item.icon }}"></i>
          </a>

          <!-- Item with submenu -->
          <a
            *ngIf="item.subMenu"
            class="side-panel__nav-link"
            (click)="toggleSubMenu($event, item)">
            {{ item.textKey | translate }}
            <i *ngIf="item.icon" class="fa fa-{{ item.icon }}"></i>
          </a>

          <!-- Submenu -->
          <ul *ngIf="item.subMenu" class="side-panel__submenu">
            <li
              *ngFor="let subItem of item.subMenu"
              class="side-panel__submenu-item"
              [routerLinkActive]="['side-panel__submenu-item--active']">

              <!-- External link -->
              <a
                *ngIf="subItem.link && isExternalLink(subItem.link)"
                class="side-panel__submenu-link"
                [href]="subItem.link"
                target="_blank"
                (click)="onSubMenuItemClick(subItem)">
                {{ subItem.textKey | translate }}
              </a>

              <!-- Internal link -->
              <a
                *ngIf="subItem.link && !isExternalLink(subItem.link)"
                class="side-panel__submenu-link"
                [routerLink]="subItem.link"
                (click)="onSubMenuItemClick(subItem)">
                {{ subItem.textKey | translate }}
              </a>

              <!-- Event handler (no link) -->
              <a
                *ngIf="!subItem.link"
                class="side-panel__submenu-link"
                (click)="onMenuEventHandler(subItem.clickHandler)">
                {{ subItem.textKey | translate }}
              </a>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </nav>

  <!-- Profile Section -->
  <div class="side-panel__profile">
    <div class="side-panel__profile-name">{{ user?.fullName }}</div>
    <div class="side-panel__profile-actions">
      <a class="side-panel__profile-link" [routerLink]="['/release-library']" (click)="close()">
        {{ "HEADER.RELEASE_LIBRARY" | translate }}
      </a>
      <a class="side-panel__profile-link" [routerLink]="['/my-profile']" (click)="close()">
        {{ "HEADER.MY_PROFILE" | translate }}
      </a>
      <a class="side-panel__profile-link" (click)="onLogout()">
        {{ "HEADER.LOGOUT" | translate }}
      </a>
    </div>
  </div>
</aside>
